<template>
  <!-- 首页 -->
  <div class="page-home">
    <!-- banner -->
    <div class="banner-box">
      <div class="swiper-container1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" :class="{ 'g-pointer': item.url }" v-for="(item, index) in data.Carousels"
            :key="index" @click="goOutLink(item)">
            <img :src="item.picId" alt="">
          </div>
        </div>
        <!-- <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div> -->
        <div class="swiper-pagination swiper-pagination1"></div>
      </div>
    </div>

    <!-- 今日开馆 -->
    <div class="section section-today">
      <div class="section-wrap">
        <div class="left">
          <h2>
            <img src="~@images/icon-clack.png" alt="">
            <span class="mr-20">{{ infoData.openStatus }}</span>
            <span v-if="infoData.openTime">{{ infoData.openTime }} - {{ infoData.closeTime }}</span>
          </h2>
          <p>开放时间 ｜周二至周日开放 周一闭馆（除法定节假日）、除夕闭馆 </p>
          <p>09:00 - 17:00 16:30停止入场</p>
          <!-- <p>11月1日至3月31日 ｜ 09:00 - 16:30 16:00停止入场 </p> -->
          <p>车辆南门出入 | 观众西门出入 </p>
        </div>

        <div class="right">
          <h2>
            <img src="~@images/icon-date.png" alt="" style="margin-left:-5px;">
            免费参观 - <router-link tag="a" :to="'/museum/ticket?type=2'">查看须知</router-link>
          </h2>
          <p>
            <img src="~@images/today-1.png" alt="">
            定时讲解服务 -
            <router-link tag="a" :to="'/museum/explain?type=6'">查看讲解时间表</router-link>
          </p>
          <p>
            <img src="~@images/today-2.png" alt="">
            语音导览服务 -
            <router-link tag="a" :to="'/museum/voice?type=6'">立即查看</router-link>
          </p>
          <p>
            <img src="~@images/today-3.png" alt="">
            交通路线 - <router-link tag="a" :to="'/museum/traffic?type=3'">立即查看</router-link>
          </p>
          <p>
            <img src="~@images/today-4.png" alt="">
            观众餐吧 - <router-link tag="a" :to="'/museum/dinning-bar?type=6'">查看位置</router-link>
          </p>
          <p>
            <img src="~@images/today-5.png" alt="">
            免费无线网络 - <router-link tag="a" :to="'/museum/dinning-bar?type=6&isWifi=1'">立即查看</router-link>
          </p>
        </div>
      </div>
    </div>

    <!-- 正在展出 -->
    <div class="section section-display">
      <div class="section-wrap display-wrap">
        <h1 class="title m-font-1">
          正在展出
          <router-link tag="a" :to="'/exhibition?type=1'" class="g-btn-more">查看更多</router-link>
        </h1>

        <div class="display-list g-activity-list">
          <router-link tag="div" :to="'/exhibition/detail?pageType=1&id=' + item.id" class="item g-card-1"
            v-for="(item, index) in data.zlList" :key="index">
            <div class="pic-box">
              <img v-lazy="item.mainPic" alt="">
              <!-- <div class="name-fl">精品</div> -->
              <!-- <div class="icon-play" @click="goDetailVideo(item)"></div> -->
            </div>
            <div class="info">
              <h2 style="margin-bottom:40px;">{{ item.name }}</h2>
              <p class="mb-10">{{ item.beginTime.replaceAll('-', '.') }}-{{ item.endTime.replaceAll('-', '.') }}</p>
              <p>{{ item.address }}</p>
            </div>

            <div class="btn-sign m-font-4">查看展览</div>
          </router-link>
        </div>
        <!-- <router-link tag="div" to="/education" class="g-btn-more color2" style="margin-top:20px;"><span>查看更多</span></router-link> -->
      </div>
    </div>

    <!-- 资讯 -->
    <div class="section section-dynamic">
      <div class="section-wrap">
        <div class="content-box info-wrap">
          <h1 class="title m-font-1">
            辽博资讯
            <router-link tag="a" :to="'/about?pageType=2'" class="g-btn-more">查看更多</router-link>
          </h1>
          <div class="list">
            <router-link :to="'/about/detail?pageType=2&id=' + item.id" class="item g-card-2"
              v-for="(item, index) in data.infoList" :key="index">
              <div class="pic-box">
                <img v-lazy="item.imgUrl" alt="">
              </div>
              <div class="g-border-box white">
                <div class="g-border">
                  <div class="info">
                    <div class="top">
                      <p class="time m-font-2">{{ item.createTimeStr }}</p>
                      <h2 class="ell m-font-2">{{ item.title }}</h2>
                    </div>
                    <p class="desc two-ell">{{ item.content }}</p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="content-box notice-wrap">
          <h1 class="title m-font-1">
            通知公告
            <router-link tag="a" :to="'/notice'" class="g-btn-more">查看更多</router-link>
          </h1>
          <div class="list">
            <div @click="goDetail(item)" class="item g-pointer" v-for="(item, index) in data.noticeList" :key="index">
              <p class="time two-ell m-font-2">{{ item.createTimeStr }}</p>
              <h2 class="ell m-font-2">{{ item.title }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 社教活动 -->
    <div class="section section-activity">
      <div class="section-wrap">
        <h1 class="title m-font-1">
          社教活动
          <router-link tag="a" :to="'/education'" class="g-btn-more">查看更多</router-link>
        </h1>
        <moduleActivity :dataList="data.activityList"></moduleActivity>
      </div>
    </div>

    <!-- 讲堂、视频 -->
    <div class="section section-class-video">
      <div class="section-wrap">
        <div class="class-wrap">
          <h1 class="title m-font-1">
            辽博讲堂
            <router-link tag="a" :to="'/research?pageType=5'" class="g-btn-more">查看更多</router-link>
          </h1>
          <moduleClass :dataList="data.classList" :eleClass="'.class-wrap'"></moduleClass>
        </div>

        <div class="video-wrap">
          <h1 class="title m-font-1">
            视频资源
            <router-link tag="a" :to="'/video'" class="g-btn-more">查看更多</router-link>
          </h1>
          <moduleClass :dataList="data.videoList" :eleClass="'.video-wrap'" :busType="'2'"></moduleClass>
        </div>
      </div>
    </div>

    <!-- 探索更多 -->
    <div class="section section-more">
      <div class="section-wrap">
        <h1 class="title m-font-1">
          探索更多
        </h1>
        <moduleMore></moduleMore>
      </div>
    </div>

    <!-- <cmpBackTop></cmpBackTop> -->

    <cmpVideoDialog ref="cmpVideoDialog"></cmpVideoDialog>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
// import cmpBackTop from '@cmp/back-top'

import moduleClass from './module-class.vue'
import moduleActivity from './module-activity.vue'
import moduleMore from './module-more.vue'
import cmpVideoDialog from '@cmp/video-dialog'
// import 'swiper/swiper-bundle.css';  // 6以上 部分api有问题 eg:slidesPerColumn无效
// import cmpTitle from '@cmp/cmp-title'
export default {
  components: {
    // cmpBackTop,
    moduleClass,
    moduleActivity,
    moduleMore,
    cmpVideoDialog
  },
  data() {
    return {
      // data: [],
      listLoading: false,
      activityList: [],
      moreDataList: [],

      data: {
        Carousels: [],
        classList: [],
        infoList: [],
        noticeList: [],
        zlList: [],
        videoList: [],
        activityList: [],
      },
      infoData: {}
    }
  },
  methods: {
    getData() {
      // banner
      this.$http
        .get('../singleMuseum/webapi/banner', {})
        .then(res => {
          if (res.success) {
            this.data.Carousels = res.result
            this.initSwiperBanner()
          } else {
            this.$message.error(res.message)
          }
        })

      // 其他数据
      this.$http
        .get('../singleMuseum/webapi/index', {})
        .then(res => {
          if (res.success) {
            this.infoData = res.result.info
            this.data.classList = [res.result.classroom]
            this.data.videoList = [res.result.video]
          } else {
            this.$message.error(res.message)
          }
        })

      // 重大事件和灰度  todo 
      // this.$http
      //   .get('../singleMuseum/webapi/getVipGrayWwjd', {
      //     currentPage: 1,
      //     size: 4
      //   })
      //   .then(res => {
      //     if (res.success) {
      //       // this.data.classList = res.result
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })

      // 资讯
      this.$http
        .get('../singleMuseum/webapi/information', {
          currentPage: 1,
          size: 2
        })
        .then(res => {
          if (res.success) {
            this.data.infoList = res.result
          } else {
            this.$message.error(res.message)
          }
        })

      // 通知
      this.$http
        .get('../singleMuseum/webapi/notice', {
          currentPage: 1,
          size: 4
        })
        .then(res => {
          if (res.success) {
            this.data.noticeList = res.result
          } else {
            this.$message.error(res.message)
          }
        })

      // 正在展出
      this.$http
        .get('../singleMuseum/applet/exhibition/zlList', {
          currentPage: 1,
          size: 2,
          type: '1'
        })
        .then(res => {
          if (res.success) {
            this.data.zlList = res.result.records
          } else {
            this.$message.error(res.message)
          }
        })

      // 讲堂
      // this.$http
      //   .get('../singleMuseum/applet/classRoom/list', {
      //     currentPage: 1,
      //     size: 4,
      //     type: '2'
      //   })
      //   .then(res => {
      //     if (res.success) {
      //       this.data.classList = res.result
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })

      // // 视频资源
      // this.$http
      //   .get('../singleMuseum/collectDict/getSysDictList', {
      //     currentPage: 1,
      //     size: 4
      //   })
      //   .then(res => {
      //     if (res.success) {
      //       this.data.videoList = res.result
      //     } else {
      //       this.$message.error(res.message)
      //     }
      //   })

      // 活动
      this.$http
        .get('../singleMuseum/api/bsActivity/getActivityListForPublic', {
          currentPage: 1,
          size: 6
        })
        .then(res => {
          if (res.success) {
            this.data.activityList = res.result
          } else {
            this.$message.error(res.message)
          }
        })
    },
    goDetail(obj) {
      this.$router.push({
        path: '/notice/detail',
        query: { id: obj.id, pageType: obj.uniqueName }
      })
      // if (obj.fileIds) {
      //   let pdfUrl = obj.fileList && obj.fileList[0].attPath
      //   window.open(pdfUrl, '_blank')
      // } else {
      //   this.$router.push({
      //     path: '/notice/detail',
      //     query: { id: obj.id, pageType: obj.uniqueName }
      //   })
      // }
    },
    getData1() {
      this.$http
        .get('/public/index.do', {})
        // .get('../api/common/index', {})
        .then(res => {
          if (res.success) {
            // todo dele
            // res.data.tempExhibit[0].name = '123造像艺术展'
            // res.data.recommentCollect = res.data.recommentCollect.concat(res.data.recommentCollect).concat(res.data.recommentCollect)

            // if(res.data.research && res.data.research.length<6) {
            //   for(let i = 0; i <= 6-res.data.research.length ; i++) {
            //     res.data.research.push({})
            //   }
            // }
            // console.log(999, res.data.research)

            // if(res.data.research && res.data.research.length<6) {
            //   for(let i = 0; i <= 6-res.data.research.length ; i++) {
            //     res.data.research.push({})
            //   }
            // }
            // console.log(999, res.data.research)

            res.data.hotSpreadtrum = res.data.hotSpreadtrum.slice(0, 2)
            res.data.research = res.data.research.slice(0, 4)

            res.data.hotVideo = res.data.hotVideo.slice(0, 2)

            this.data = res.data

            this.initSwiperBanner()

            this.activityList = res.data.Carousels
            this.moreDataList = res.data.Carousels

            console.log(897, this.activityList)

          } else {
            this.$message.error(res.message)
          }
        })
    },
    initSwiperBanner() {
      this.$nextTick(() => {
        let swiper = new Swiper(".swiper-container1", {
          // centeredSlides: true,
          effect: 'fade',
          // fade: {
          //   crossFade: true,
          // },
          autoplay: 5000,
          // speed: 5000,
          loop: true,
          // prevButton:'.swiper-button-prev',
          // nextButton:'.swiper-button-next',
          pagination: '.swiper-container1 .swiper-pagination1',
          paginationClickable: true,
          autoplayDisableOnInteraction: false, // 用户操作 swiper 之后自动切换不会停止
          // 768: {  //当屏幕宽度小于等于768
          //   slidesPerView: 2,
          //   spaceBetween: 20,
          // },
          // 1200: {
          //   //当屏幕宽度小于等于320
          //   slidesPerView: 1,
          //   spaceBetween: 10
          // },
          // prevButton:'.banner-box .swiper-button-prev',
          // nextButton:'.banner-box .swiper-button-next',
          // onSlideChangeStart: function(swiper){
          //   // console.log(swiper.realIndex)
          //   vm.swiperBannerIndex = swiper.realIndex + 1;
          //   vm.currentBanner = vm.data.indexBanner[swiper.realIndex]
          //   if(vm.swiperBannerIndex < vm.data.indexBanner.length) {
          //     vm.nextBanner = vm.data.indexBanner[vm.swiperBannerIndex]
          //   } else {
          //     vm.nextBanner = vm.data.indexBanner[0]
          //   }
          // }
          // navigation: {
          //   nextEl: '.swiper-container3 .swiper-button-next',
          //   prevEl: '.swiper-container3 .swiper-button-prev'
          // },
          // on: {
          //   slideChange: function() {
          //     vm.swiperColectIndex = this.realIndex + 1;
          //   }
          // }
        })
      })
    },
    goDetailVideo(item) {

      this.$refs.cmpVideoDialog.init(item.url, String(item.id))
      // window.open(item.url)
    },
    goOutLink(item) {
      console.log(item.url)
      item.url && window.open(item.url)
    }
  },
  created() {
    this.getData()
    // this.getData1()
  }
}
</script>

<style lang="scss" scoped>
.page-home {
  min-width: $minWidth;
  min-height: 680px;

  img {
    // object-fit: cover;
  }

  .swiper-container1 {
    position: relative;
    width: 100%;
    height: 680px;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      width: 100%;
      height: 100%;

      // height: 520px;
      // background-image: url(~@images/home/banner.jpg);
      // // background-position: center top;
      // background-position: center center;
      // background-repeat: no-repeat;
      // background-size: cover;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transform: scale(1);
        transition: all 5s;
      }

      // &:after {
      //   content: '';
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   width: 100%;
      //   height: 100%;
      //   background: radial-gradient(
      //     rgba(255, 255, 255, 0),
      //     rgba(241, 241, 241, 0.05),
      //     rgba(17, 17, 17, 0.93),
      //     #000000
      //   );
      //   opacity: 0.5;
      // }
      &.swiper-slide-active {
        img {
          transform: scale(1.03);
        }
      }
    }

    // image.active {
    //   transform:none;
    //   transition:all 0.2s ease-in0s;
    // }

    // image.quiet {
    //   transform: scale(0.8333333);
    //   transition:all 0.2s ease-in0s;
    // }

    // /deep/ .swiper-pagination-bullet-active {
    //   background: #fff;
    // }

    /deep/ .swiper-pagination-bullet {
      bottom: 24px;
      width: 30px !important;
      height: 36px !important;
      // border-radius: 100%;
      background: url(~@images/icon-bullet.png) no-repeat center center !important;
      background-size: 100% 100% !important;
      opacity: 1;
    }

    /deep/ .swiper-pagination-bullet-active {
      // background: $primary !important;
      background: url(~@images/icon-bullet-active.png) no-repeat center center !important;
      background-size: 100% 100% !important;
      opacity: 1;
    }
  }

  // 公共的轮播样式
  /deep/ .m-home-swiper {
    width: 100%;

    // .img-title {
    //   width: 422px;
    //   height: 145px;
    //   margin: 50px 0 36px;
    // }
    .btn {
      width: 144px;
      height: 24px;
      margin: 40px auto 0;
      text-align: center;
      cursor: pointer;

      .more {
        width: 100%;
        height: 100%;
        display: inline-block;
        // background: url(../../assets/images/home/btn-bg.png) no-repeat center;
        background-size: 100% 100%;
        font-size: 16px;
        font-weight: bold;
        color: #7f3222;
        line-height: 24px;
      }
    }

    /*先去掉默认样式*/
    .swiper-button-prev:after {
      display: none;
    }

    .swiper-button-next:after {
      display: none;
    }

    /*再自定义样式*/
    .swiper-button-prev {
      width: 56px;
      height: 56px;
      background: url('~@images/icon_left@2x.png') no-repeat;
      background-size: 100% 100%;
      left: 0;
    }

    .swiper-button-next {
      right: 0;
      width: 56px;
      height: 56px;
      background: url('~@images/icon_right@2x.png') no-repeat;
      background-size: 100% 100%;
    }
  }

  .point-box {
    .point-r {
      position: absolute;
      left: -130px;
      top: -15px;
      margin-right: 10px;
      display: none;

      &:after {
        position: absolute;
        right: -14px;
        top: 50%;
        margin-top: -4px;
        display: block;
        content: '';
        width: 0;
        height: 0;
        border: solid 8px transparent;
        border-left: solid 6px $primary;
      }
    }

    &:hover {
      .point-r {
        display: block;
      }
    }
  }

  .section {
    padding: 60px 0;
    background-size: cover;

    .section-wrap {
      width: $minWidth;
      // width: 1204px;
      margin: 0 auto;
      // display: flex;
      // flex-direction: column;
    }
  }

  h1.title {
    color: #303030;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  // .g-card-1,
  // .g-card-2 {
  //   .info {
  //     h2 {
  //       font-size: 24px;
  //     }
  //   }
  // }

  .section-today {
    background: #f6f6f6;

    .section-wrap {
      // padding: 45px 290px;
      display: flex;
      justify-content: space-around;

      h2 {
        display: flex;
        align-items: center;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;

        img {
          height: 27px;
          margin-right: 10px;
        }

        a {
          border-bottom: solid 1px rgba($color: #000000, $alpha: 0.7);
          margin-left: 5px;

          &:hover {
            color: $primary;
            border-color: $primary;
          }
        }
      }

      p {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: rgba($color: #000000, $alpha: 0.7);

        img {
          width: 20px;
          margin-right: 10px;
          position: relative;
          top: 2px;
        }

        a {
          font-size: 14px;
          margin-left: 6px;
          border-bottom: solid 1px rgba($color: #000000, $alpha: 0.7);

          &:hover {
            color: $primary;
            border-color: $primary;
          }
        }
      }
    }
  }

  .section-display {
    .display-list {
      .pic-box {
        img {
          height: 440px;
        }
      }

      .item {
        position: relative;
        width: 49%;

        &:not(:nth-child(3n)) {
          margin: 0;
        }

        &:not(:nth-child(2n)) {
          margin-right: 2%;
        }

        // &:nth-child(2n+1) {
        //   .info {
        // background: $primary;
        // color: #fff;
        // h2 {
        //   color: #fff;
        // }
        //   }
        // }
        &:nth-child(2n) {
          .info {
            background: #f6f6f6;
          }

          .btn-sign {
            color: #fff;
            background: #608267;
          }
        }

        .info {
          padding: 30px 40px;
          border: none;
          background: #f6f6f6;
          // background: $primary;
          // color: #fff;
          // h2 {
          //   color: #fff;
          // }
        }

        .btn-sign {
          position: absolute;
          right: 40px;
          bottom: 30px;
          // font-size: 18px;
          width: 80px;
          height: 80px;
          line-height: 80px;
          text-align: center;
          border-radius: 100%;
          background: $primary;
          color: #fff;
        }

        &:hover {
          .info {
            background: $primary;
            color: #fff;

            h2 {
              color: #fff;
            }
          }

          .btn-sign {
            background: #fff;
            color: $primary;
          }

          &:nth-child(2n) {
            .info {
              background: #608267;
            }

            .btn-sign {
              color: #608267;
            }
          }
        }
      }
    }
  }

  .section-dynamic .section-wrap {
    display: flex;
    justify-content: space-between;

    .content-box {
      width: 48.8%;
      font-size: 18px;
      line-height: 36px;
      color: rgba($color: #303030, $alpha: 0.7);

      .time {
        color: rgba($color: #303030, $alpha: 0.7);
        line-height: 36px;
        // font-size: 24px;
      }

      h2 {
        margin-top: 16px;
        margin-bottom: 50px;
        line-height: 36px;
        // font-size: 24px;
        // font-weight: bold;
        color: #000000;
      }

      .item {
        height: 280px;
        box-sizing: border-box;
        border-bottom: solid 1px rgba($color: #000000, $alpha: 0.2);
      }
    }

    .info-wrap {
      .item {
        padding: 12px 0;
        margin-bottom: 0;

        .pic-box img {
          width: 256px;
          height: 256px;
          // object-fit: contain;
          // object-position: left;
          // object-position: left top;
        }

        .info {
          padding-top: 10px;
          height: 100%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: initial;
        }
      }
    }

    .notice-wrap {
      .item {
        padding: 20px 0;
        height: 140px;
      }
    }
  }

  .section-class-video .section-wrap {
    display: flex;
    justify-content: space-between;

    .class-wrap {
      width: 48.8%;
    }

    .video-wrap {
      width: 48.8%;
    }
  }
}
</style>
